import { lazyLoad } from 'utils/lazy';

export const UserInfo = lazyLoad(
  () => import('./UserInfo'),
  (m) => m.UserInfo
);
